import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { Configuration } from '@/classes/models'

export default class ConfigurationService {
  /**
   * Get configurations
   *
   * @param {Context} context
   * @param {TableRequest|QueryRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (context, parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(`${this.endpoint(context, ['business', 'merchant'])}/configurations`, {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Map to Configuration
      response.data = response.data.map(configuration => new Configuration(configuration))

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get a configuration.
   *
   * @param {Context} context
   *
   * @return {Promise}
   */
  static get (context) {
    let request = portalApi.get(this.endpoint(context)).then(response => {
      return response.data
    })

    return request.then(response => {
      // Map to Configuration
      response.data = new Configuration(response.data)

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Create a configuration
   *
   * @param {Context} context
   * @param {Object} data
   *
   * @return {Promise}
   */
  static add (context, data) {
    return portalApi.post(`${this.endpoint(context, ['business', 'merchant'])}/configurations`, data).then(response => {
      return response.data
    }).then(response => {
      // Map to Configuration
      response.data = new Configuration(response.data)

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Update a configuration.
   *
   * @param {Context} context
   * @param {Object} data
   *
   * @return {Promise}
   */
  static update (context, data) {
    return portalApi.put(this.endpoint(context), data)
  }

  /**
   * Delete a configuration.
   *
   * @param {Context} context
   *
   * @return {Promise}
   */
  static delete (context) {
    return portalApi.delete(this.endpoint(context))
  }

  /**
   * Get a payment method configuration of a configuration.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static getPaymentMethodConfiguration (context, reference) {
    return portalApi.get(`${this.endpoint(context)}/${reference.toLowerCase()}`).then(response => {
      return response.data
    })
  }

  /**
   * Update a payment method configuration of a configuration.
   *
   * @param {Context} context
   * @param {string} reference
   * @param {Object} configuration
   *
   * @return {Promise}
   */
  static updatePaymentMethodConfiguration (context, reference, configuration) {
    return portalApi.put(`${this.endpoint(context)}/${reference.toLowerCase()}`, configuration)
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context, segments = ['business', 'merchant', 'configuration']) {
    return `${context.endpoint(segments)}`
  }
}
